import { useState } from 'react';

export function StagingBanner({ isStaging }: { isStaging: boolean }) {
    const [dismissed, setDismissed] = useState(false);

    if (!isStaging || dismissed) return null;

    return (
        <div
            style={{
                background: '#f59e0b',
                color: '#000',
                textAlign: 'center',
                padding: '4px 0',
                fontSize: '13px',
                fontWeight: 700,
                letterSpacing: '.05em',
                zIndex: 99999,
                position: 'relative',
            }}
        >
            STAGING ENVIRONMENT
            <button
                onClick={() => setDismissed(true)}
                style={{
                    position: 'absolute',
                    right: '8px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '16px',
                    lineHeight: 1,
                    padding: '0 4px',
                    color: '#000',
                }}
                aria-label="Dismiss staging banner"
            >
                &times;
            </button>
        </div>
    );
}
